<template>
  <div class="startTestImage" :class="{startAnimation: startAnimation}" @click="nextQuestions()" >
    <img class="startBackground" src="../assets/images/start/start_bg.jpg">
    <img class="fadeSparkIn sparkBackground sparkBackground--one" src="../assets/images/start/start_s1.png">
    
    <div class="fadeItemIn startCharacter startCharacter--iron" >
      <img class="ironImage" src="../assets/images/start/start_iron_man.png">
    </div>
    <div class="fadeItemIn startCharacter startCharacter--panther" >
      <img class="pantherImage" src="../assets/images/start/start_black_panther.png">
    </div>
    <div class="fadeItemIn startCharacter startCharacter--hulk" >
      <img class="hulkImage" src="../assets/images/start/start_hulk.png">
    </div>
    <div class="fadeItemIn startCharacter startCharacter--rocket" >
      <img class="rocketImage" src="../assets/images/start/start_rocket.png">
    </div>
    <div class="fadeItemIn startCharacter startCharacter--wasp" >
      <img class="waspImage" src="../assets/images/start/start_wasp.png">
    </div>

    <img class="fadeSparkIn sparkBackground sparkBackground--two" src="../assets/images/start/start_s2.png">

    <img class="fadeItemIn startMoreLogo" src="../assets/images/start/start_moreLogo.png">

    <img class="fadeSparkIn sparkBackground sparkBackground--three" src="../assets/images/start/start_s3.png">

    <img class="get-started-image" src="../assets/images/start/get-started.png">


    <!-- Preloaded Images -->

    <img src="../assets/images/characters/Rocket-bg.png" alt="Preloaded Image" class="preloadImage">

    <img src="../assets/images/frame2.png" alt="Preloaded Image" class="preloadImage">
    <img src="../assets/images/Marvel_wireframe_assets_SkyBackground.jpg" alt="Preloaded Image" class="preloadImage">
    <img src="../assets/images/close_full_x2.png" alt="Preloaded Image" class="preloadImage">
    <img src="../assets/images/engineering-logo.png" alt="Preloaded Image" class="preloadImage">
    <img src="../assets/images/MoreHeroesNeeded_Exit_x2.png" alt="Preloaded Image" class="preloadImage">
    <img src="../assets/images/more-needed-logo.png" alt="Preloaded Image" class="preloadImage">
    <img src="../assets/images/questions/MoreHeroesNeeded_Question_Answer_x2.png" alt="Preloaded Image" class="preloadImage">
    <img src="../assets/images/questions/MoreHeroesNeeded_Question_x2.png" alt="Preloaded Image" class="preloadImage">
    <img src="../assets/images/progress/ProgressBar.png" alt="Preloaded Image" class="preloadImage">
    <img src="../assets/images/progress/progress.png" alt="Preloaded Image" class="preloadImage">
    <img src="../assets/images/progress/MoreHeroesNeeded_Progress_Bar_x2.png" alt="Preloaded Image" class="preloadImage">
  </div>
</template>

<script>
export default {
  data() {
    return {
      nextLink: 'one',
      startAnimation: false
    }
  },
  mounted () {
    this.startAnimationMethod()
  },
  computed: {
    testStartCheck () {
      return this.$store.getters.StoreQuestionData.startTest
    }
  },
  methods: {
    nextQuestions () {
      this.$router.push('/' + this.nextLink)
    },
    startAnimationMethod () {
      console.log('startAnimation: ' + this.testStartCheck)
      if (this.testStartCheck) {
        setTimeout(() => {
          this.startAnimation = true
        }, 50)
      } else {
        this.startAnimation = false
      }
    }
  },
  watch: {
    testStartCheck () {
      this.startAnimationMethod()
    }
  }
}
</script>

